import { goToPosition, useGamePlay } from "../../ducks/gamePlay";
import { FaFastBackward } from "react-icons/fa";
import { FaStepForward } from "react-icons/fa";
import { FaFastForward } from "react-icons/fa";
import { FaStepBackward } from "react-icons/fa";
import MoveButton from "@/src/components/MoveButton";

export default function MoveButtons() {
  const { moves, positionIndex } = useGamePlay();

  return (
    <div className="flex justify-center py-2 mx-5">
      <MoveButton
        disabled={positionIndex === 0}
        onClick={() => goToPosition(0)}
      >
        <FaFastBackward />
      </MoveButton>
      <MoveButton
        disabled={positionIndex === 0}
        onClick={() => {
          if (positionIndex > 0) goToPosition(positionIndex - 1);
        }}
      >
        <FaStepBackward />
      </MoveButton>
      <MoveButton
        disabled={positionIndex === moves.length}
        onClick={() => {
          if (positionIndex < moves.length) goToPosition(positionIndex + 1);
        }}
      >
        <FaStepForward />
      </MoveButton>
      <MoveButton
        disabled={positionIndex === moves.length}
        onClick={() => goToPosition(moves.length)}
      >
        <FaFastForward />
      </MoveButton>
    </div>
  );
}
